export default "__VITE_ASSET__cb86913f__"